import React from 'react';
import LanguageToggle from '../languagetoggle/LanguageToggle'; // import the LanguageToggle component

import './Navbar.css';

type NavbarProps = {
    children?: React.ReactNode;
    language: 'fi' | 'en';
    onToggle: (lang: 'fi' | 'en') => void;
};

const Navbar: React.FC<NavbarProps> = ({ children, language, onToggle }) => {
    return (
        <div className="navbar">
            <div className="navbar__header">
                <h1>NEMORA.IO</h1>
            <LanguageToggle language={language} onToggle={onToggle} />
            </div>
        </div>
    );
};

export default Navbar;
